<script>
import _ from 'lodash'
import moment from 'moment'
// import TimeUtils from '@/utils/time'
import OrgService from '@/request/user/org'
import TempFollowupService from '@/request/template/Followup'
import TempFollowupPlanService from '@/request/template/FollowupPlan'
import TempFollowupPlanEdit from './followup-plan-edit'
export default {
  name: 'TempFollowupEdit',
  components: {
    TempFollowupPlanEdit
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      defaultfu: {
        level: 1
      },
      hospitals: [],
      back: {},
      followup: {},
      forgs: [],
      oldPlans: [],
      plans: [],
      followupRuleValidate: {
        name: [{required: true, message: '名称不能为空', trigger: 'blur'}]
      }
    }
  },
  computed: {},
  created () {
    this.listHospital()
    this.init()
  },
  watch: {
    data () {
      this.init()
    }
  },
  methods: {
    init () {
      this.back = _.defaultsDeep(this.data, this.defaultfu)
      this.followup = _.defaultsDeep(this.data, this.defaultfu)
      this.listFollowupOrgs()
      this.listPlan()
    },
    listHospital () {
      OrgService.listOrg({
        parents: 1,
        descendant: 1,
        typeSns: 'lx0001001'
      }).then(res => {
        this.hospitals = _.cloneDeep(res.result || [])
      })
    },
    listFollowupOrgs () {
      if (_.isEmpty(this.followup) || !this.followup.id) {
        this.forgs = []
        return
      }
      TempFollowupService.listFollowupOrg({
        ftid: this.followup.id
      }).then(res => {
        this.forgs = _.clone(res.result || [])
      })
    },
    listPlan () {
      if (_.isEmpty(this.followup) || !this.followup.id) {
        this.plans = []
        return
      }
      TempFollowupPlanService.list({
        fid: this.followup.id
      }).then(res => {
        this.oldPlans = _.cloneDeep(res.result || [])
        this.plans = _.cloneDeep(res.result || [])
        this.sort()
      })
    },
    sort () {
      if (_.isEmpty(this.plans)) {
        return
      }
      let list = _.cloneDeep(this.plans)
      list = (_.sortBy(list, ['duration']))
      _.forEach(list, (item, index) => {
        if (item.num === (index + 1)) {
          return
        }
        item.num = index + 1
        if (_.isEqual(this.plans[index], item)) {
          return
        }
        this.$set(this.plans, index, item)
      })
    },
    durationFormat (duration) {
      if (!duration) {
        duration = 118800000
      }
      let _duration = moment(duration).startOf('day')
      let time = duration - _duration.valueOf()
      let zero = moment(0).startOf('day')
      let years = _duration.clone().diff(zero, 'years', true)
      let months = _duration.clone().diff(zero, 'months', true)
      let weeks = _duration.clone().diff(zero, 'weeks', true)
      let days = _duration.clone().diff(zero, 'days', true)
      let mills = _duration.clone().diff(zero)
      let count = 0
      let benchmark = 'days'
      if (_.isInteger(years)) {
        count = years
        benchmark = 'years'
      } else if (_.isInteger(months)) {
        count = months
        benchmark = 'months'
      } else if (_.isInteger(weeks)) {
        count = weeks
        benchmark = 'weeks'
      } else if (_.isInteger(days)) {
        count = days
        benchmark = 'days'
      } else {
        count = 0
        benchmark = 'days'
        time += mills
      }
      time += 8 * 60 * 60 * 1000
      return {
        'count': count,
        'benchmark': benchmark,
        'time': time
      }
    },
    addPlan () {
      let format = this.plans.length === 0 ? null : this.durationFormat(this.plans[this.plans.length - 1].duration)
      let nextDuration = format === null ? 118800000 : moment(0).startOf('day').clone().add(format.count + 1, format.benchmark).startOf('day') + format.time - (8 * 60 * 60 * 1000)
      this.plans.push({
        fid: this.followup.id,
        duration: nextDuration || 118800000,
        label: null,
        inquiry: null
      })
      this.sort()
    },
    deletePlan (item) {
      if (!item.num) {
        return
      }
      let list = _.cloneDeep(this.plans)
      if (!item.id) {
        _.remove(list, plan => {
          return plan.num === item.num
        })
        this.plans = list
        this.sort()
        return
      }
      this.$confirm('这个是已经保存的项目，确认删除这个项目吗?', '提示', {type: 'warning'}).then(() => {
        TempFollowupPlanService.delete({
          id: item.id
        }).then(res => {
          let result = res.result
          if (!result) {
            return
          }
          _.remove(list, plan => {
            return plan.id === result.id
          })
          _.remove(this.oldPlans, op => {
            return op.id === result.id
          })
          this.plans = list
          this.sort()
        }).catch(error => {
          this.$message.error(error || '删除失败')
        })
      }, () => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    changePlan (item) {
      if (!item.num) {
        return
      }
      let index = item.num - 1
      this.$set(this.plans, index, item)
      this.sort()
    },
    save () {
      if (_.isEmpty(this.hospitals)) {
        this.followup.level = -1
      }
      if (_.isEqual(this.followup, this.back) && this.followup.id) {
        this.savePlans().then(() => {
          this.$emit('save-done', this.followup)
        }).catch(error => {
          this.$message.error(error)
        })
        return
      }
      this.$refs['editFollowupForm'].validate(valid => {
        if (!valid) {
          this.$message.error('表单验证失败!')
          return
        }
        if (_.isEmpty(this.plans)) {
          this.$confirm('随访事项不能为空', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
          return
        }
        TempFollowupService.save(this.followup).then(res => {
          this.followup = _.cloneDeep(res.result)
          Promise.all([this.savePlans(), this.saveForgs()]).then(() => {
            this.$emit('save-done', this.followup)
          }).catch(error => {
            this.$message.error(error)
          })
        }).catch(error => {
          this.$message.error(error || '保存模板失败')
        })
      })
    },
    savePlans () {
      return new Promise((resolve, reject) => {
        if (!this.followup.id) {
          reject(new Error('随访模板还没有保存成功，不能保存项目'))
          return
        }
        if (_.isEmpty(this.plans)) {
          resolve()
          return
        }
        let list = _.cloneDeep(this.plans)
        _.forEach(this.oldPlans, op => {
          _.remove(list, item => {
            return _.isEqual(item, op)
          })
        })
        if (_.isEmpty(list)) {
          resolve()
          return
        }
        let ps = []
        _.forEach(list, item => {
          if (!item.fid) {
            item.fid = this.followup.id
          }
          ps.push(TempFollowupPlanService.save(item))
        })
        Promise.all(ps).then(() => {
          this.listPlan()
          resolve()
        })
      })
    },
    saveForgs () {
      return new Promise((resolve, reject) => {
        if (!this.followup.id) {
          reject(new Error('随访模板还没有保存成功，不能共享到医院'))
          return
        }
        if (_.isEmpty(this.hospitals)) {
          resolve()
          return
        }
        let ps = []
        _.forEach(this.hospitals, hospital => {
          if (_.findIndex(this.forgs, {'oid': hospital.id}) >= 0) {
            return
          }
          ps.push(TempFollowupService.saveFollowupOrg({
            ftid: this.followup.id,
            oid: hospital.id
          }))
        })
        Promise.all(ps).then(() => {
          resolve()
        })
      })
    },
    deleteFollowup () {
      if (!this.followup.id) {
        this.$message('不能删除未保存的模板')
        return
      }
      this.$confirm('删除后不可恢复，确定删除这个随访模板吗?', '您即将删除随访模板', {type: 'warning'}).then(() => {
        TempFollowupService.delete({
          id: this.followup.id
        }).then(res => {
          this.$emit('delete-done', res.result)
        }).catch(error => {
          this.$message.error(error || '删除失败')
        })
      }).catch(() => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    cancle () {
      this.$emit('cancle')
    }
  },
  filters: {}
}
</script>

<template>
  <div class="followup-edit">
    <el-form inline class="demo-form-inline">
      <el-form-item>
        <el-button type="default" @click="cancle">返 回</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">保 存</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addPlan">添加随访事项</el-button>
      </el-form-item>
      <el-form-item v-if="followup.id > 0">
        <el-button type="danger" @click="deleteFollowup">删除模板</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="editFollowupForm" :model="followup" :rules="followupRuleValidate" label-width="80px">
      <!-- <el-form-item>
        <span>建立的模板会共享到您所在医院中</span>
      </el-form-item> -->
      <el-form-item label="名称" prop="name">
        <el-input v-model="followup.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="addPlan">添加随访事项</el-button>
      </el-form-item> -->
    </el-form>
    <temp-followup-plan-edit
      :data="plan"
      :key="plan.id"
      :number="index + 1"
      v-for="(plan, index) in plans"
      @remove="deletePlan"
      @change="changePlan"
    ></temp-followup-plan-edit>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
